import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTrasladoForm } from '../Validations/ValidationsTraslado';

export default function EditTrasladoForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '', terceroId: '', fecha: '', observaciones: '', sepulturaId: '', origenId: '', destineId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTraslado = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/traslados/${id}`);
                setFormData(response.data);
            } catch {
                setError('Error al cargar los datos del traslado.');
            } finally {
                setIsLoading(false);
            }
        };
        if (id) fetchTraslado();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateTrasladoForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.put(`/traslados/${id}`, formData);
                navigate('/home/traslados');
            } catch {
                setError('Error al actualizar el traslado.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto mt-8 bg-blue-50 p-6 rounded-lg shadow-lg">
            <h2 className="text-3xl font-bold mb-6 text-blue-700">Editar Traslado</h2>
            <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                    <label className="block mb-1 font-semibold">ID</label>
                    <input type="text" name="id" value={formData.id} readOnly className="w-full p-2 border rounded bg-gray-200" />
                </div>
                {[
                    { name: 'terceroId', label: 'Tercero ID' },
                    { name: 'fecha', label: 'Fecha', type: 'date' },
                    { name: 'sepulturaId', label: 'Sepultura ID' },
                    { name: 'origenId', label: 'Origen ID' },
                    { name: 'destineId', label: 'Destino ID' }
                ].map(({ name, label, type = 'text' }) => (
                    <div key={name}>
                        <label className="block mb-1 font-semibold">{label}</label>
                        <input type={type} name={name} value={formData[name]} onChange={handleChange} 
                            className={`w-full p-2 border rounded ${errors[name] ? 'border-red-500' : ''}`} required />
                        {errors[name] && <p className="text-red-500 text-xs italic">{errors[name]}</p>}
                    </div>
                ))}
                <div className="col-span-2">
                    <label className="block mb-1 font-semibold">Observaciones</label>
                    <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} 
                        className={`w-full p-2 border rounded ${errors.observaciones ? 'border-red-500' : ''}`} required />
                    {errors.observaciones && <p className="text-red-500 text-xs italic">{errors.observaciones}</p>}
                </div>
                <div className="col-span-2">
                    <button type="submit" className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700">
                        {isLoading ? 'Actualizando...' : 'Actualizar Traslado'}
                    </button>
                </div>
            </form>
        </div>
    );
}

/*
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { validateTrasladoForm } from '../Validations/ValidationsTraslado';

export default function EditTrasladoForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        id: '', terceroId: '', fecha: '', observaciones: '', sepulturaId: '', origenId: '', destinoId: ''
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTraslado = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/traslados/${id}`);
                setFormData(response.data);
            } catch {
                setError('Error al cargar los datos del traslado.');
            } finally {
                setIsLoading(false);
            }
        };
        if (id) fetchTraslado();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = await validateTrasladoForm(formData);
        if (Object.keys(validationErrors).length === 0) {
            setIsLoading(true);
            try {
                await axios.put(`/traslados/${id}`, formData);
                navigate('/home/traslados');
            } catch {
                setError('Error al actualizar el traslado.');
            } finally {
                setIsLoading(false);
            }
        } else {
            setErrors(validationErrors);
        }
    };

    if (isLoading) return <div className="text-center mt-8">Cargando...</div>;
    if (error) return <div className="text-center mt-8 text-red-500">{error}</div>;

    return (
        <div className="max-w-4xl mx-auto mt-8 bg-blue-50 p-6 rounded-lg shadow-lg">
            <h2 className="text-3xl font-bold mb-6 text-blue-700">Editar Traslado</h2>
            <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                    <label className="block mb-1 font-semibold">ID</label>
                    <input type="text" name="id" value={formData.id} readOnly className="w-full p-2 border rounded bg-gray-200" />
                </div>
                {[
                    { name: 'terceroId', label: 'Tercero ID' },
                    { name: 'fecha', label: 'Fecha', type: 'date' },
                    { name: 'sepulturaId', label: 'Sepultura ID' },
                    { name: 'origenId', label: 'Origen ID' },
                    { name: 'destinoId', label: 'Destino ID' }
                ].map(({ name, label, type = 'text' }) => (
                    <div key={name}>
                        <label className="block mb-1 font-semibold">{label}</label>
                        <input type={type} name={name} value={formData[name]} onChange={handleChange} 
                            className={`w-full p-2 border rounded ${errors[name] ? 'border-red-500' : ''}`} required />
                        {errors[name] && <p className="text-red-500 text-xs italic">{errors[name]}</p>}
                    </div>
                ))}
                <div className="col-span-2">
                    <label className="block mb-1 font-semibold">Observaciones</label>
                    <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} 
                        className={`w-full p-2 border rounded ${errors.observaciones ? 'border-red-500' : ''}`} required />
                    {errors.observaciones && <p className="text-red-500 text-xs italic">{errors.observaciones}</p>}
                </div>
                <div className="col-span-2">
                    <button type="submit" className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700">
                        {isLoading ? 'Actualizando...' : 'Actualizar Traslado'}
                    </button>
                </div>
            </form>
        </div>
    );
}
*/